import PropTypes from "prop-types";
import { memo } from "react";
import LuggageSummary from "app/pages/Booking/Quotation/Flight/LuggageSummary/LuggageSummary";

import "./MyFlightDetail.scss";
import Itinerary from "app/pages/.shared/Itinerary";
import { getSupplierClass, normalizeSupplierClassLabel } from "app/utils/utils";

const MyFlightDetail = ({
	flight = {},
	luggageMaxCount = 0,
	lugaggeCount,
	maxWeightPerCheckedBaggage,
	flightOptions = {},
	bookingCabinLuggage = {},
}) => {
	const supplierClassPerSegment = normalizeSupplierClassLabel(
		flightOptions?.flightBagageOptions?.[0]?.supplierClassPerSegment?.[0]
	);

	const shouldShowSupplierClassPerSegment =
		lugaggeCount > 0 && supplierClassPerSegment !== undefined;

	const outboundSupplierClass = shouldShowSupplierClassPerSegment
		? supplierClassPerSegment
		: getSupplierClass(flight?.outbound?.legs);
	const inboundSupplierClass = shouldShowSupplierClassPerSegment
		? supplierClassPerSegment
		: getSupplierClass(flight?.inbound?.legs);

	return (
		<div className="my-flight-detail">
			<div className="itinerary">
				<Itinerary
					inbound={flight.inbound}
					outbound={flight.outbound}
					disableDetails={true}
					displayRouteDetails={true}
					transportationType={flight?.type}
					outboundSupplierClass={outboundSupplierClass}
					inboundSupplierClass={inboundSupplierClass}
				/>
			</div>

			<LuggageSummary
				luggageMaxCount={luggageMaxCount}
				flight={flight}
				flightOptions={flightOptions}
				bookingLuggageCount={lugaggeCount}
				bookingCabinLuggage={bookingCabinLuggage}
				hideAddLuggageButton
				transportationType={flight.type}
				maxWeightPerCheckedBaggage={maxWeightPerCheckedBaggage}
			/>
		</div>
	);
};

MyFlightDetail.propTypes = {
	flight: PropTypes.object,
	luggageMaxCount: PropTypes.number,
	lugaggeCount: PropTypes.number,
	flightOptions: PropTypes.object,
	maxWeightPerCheckedBaggage: PropTypes.number,
	bookingCabinLuggage: PropTypes.object,
};

export default memo(MyFlightDetail);
